import { faBullseyeArrow } from "@fortawesome/pro-solid-svg-icons/faBullseyeArrow";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconAudience: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faBullseyeArrow} />;
};
